<template>
  <v-card
    outlined
    rounded="lg"
    elevation="1"
  >
    <v-list-item two-line>
      <v-list-item-avatar>
        <v-icon
          x-large
          color="primary"
        >
          mdi-account-circle
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium">
          {{ name }}
        </v-list-item-title>
        <v-list-item-subtitle :class="{'text-uppercase':type=='tma'}">
          {{ type=='doctor'?user.specialization||'N&frasl;A':type||'N&frasl;A' }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
            >
              mdi-dots-horizontal
            </v-icon>
          </template>
          <!-- Menu List -->
          <v-list>
            <!-- view details -->
            <v-list-item class="clickable">
              <router-link
                class="black--text option-link" 
                :to="`users/${user.id}`"
              >
                <v-list-item-title>
                  <v-icon>mdi-square-edit-outline</v-icon>
                  View&frasl;Edit
                </v-list-item-title>
              </router-link>
            </v-list-item>
            <!-- delete user -->
            <v-list-item class="clickable">
              <v-list-item-title @click="confirmDelete = true">
                <v-icon color="red">mdi-delete-outline</v-icon>
                <span
                  class="red--text option-link"
                >
                  Delete
                </span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>        
      </v-list-item-action>
    </v-list-item>

    <!-- delete popup -->
    <base-confirmation-dialog
      v-model="confirmDelete"
      message="Do you want to remove this user?"
      @confirm="deleteUser"
      @cancel="confirmDelete = false"
    ></base-confirmation-dialog>
  </v-card>
</template>

<script>
  export default {
    name: "UserCard",

    props: {
      user: {
        type: Object
      }
    },

    data: () => ({
      confirmDelete: false
    }),

    computed: {
      type() {
        return this.user.user_type
      },
      name() {
        var name = 'N⁄A';
        var user = this.user[this.type]
        if (user) {
          if (user.fullname) {
            name = user.fullname
          }
          else if (user.first_name) {
            name = user.first_name;
            name += user.last_name ? ` ${user.last_name}` : ''
          }
        }
        else {
          name = this.user.email
        }
        return name;
      }
    },

    methods: {
      async deleteUser() {
        try {
          await this.$store.dispatch('user/deleteUser', this.user.id)
          // if (response.status == 200) {
          //   this.message.success = true
          // }
          // else {
          //   this.message.error = true
          // }
        }
        catch(e) {
          console.log('[error]', e)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.option-link {
  text-decoration: none;
}
</style>